// Astrological constants and helpers.
// Tradition: Traditional Western Astrology
// House System: Classical method (30° per house, método clássico ocidental)
// ASC: Solar Ascendant = 1° of Sun sign when birth time unknown

export const ZODIAC_SIGNS = [
  { key: 'aries',       name: 'Áries',       emoji: '♈', element: 'Fogo',  dates: 'Mar 21 – Abr 19' },
  { key: 'taurus',      name: 'Touro',        emoji: '♉', element: 'Terra', dates: 'Abr 20 – Mai 20' },
  { key: 'gemini',      name: 'Gêmeos',       emoji: '♊', element: 'Ar',    dates: 'Mai 21 – Jun 20' },
  { key: 'cancer',      name: 'Câncer',       emoji: '♋', element: 'Água',  dates: 'Jun 21 – Jul 22' },
  { key: 'leo',         name: 'Leão',         emoji: '♌', element: 'Fogo',  dates: 'Jul 23 – Ago 22' },
  { key: 'virgo',       name: 'Virgem',       emoji: '♍', element: 'Terra', dates: 'Ago 23 – Set 22' },
  { key: 'libra',       name: 'Libra',        emoji: '♎', element: 'Ar',    dates: 'Set 23 – Out 22' },
  { key: 'scorpio',     name: 'Escorpião',    emoji: '♏', element: 'Água',  dates: 'Out 23 – Nov 21' },
  { key: 'sagittarius', name: 'Sagitário',    emoji: '♐', element: 'Fogo',  dates: 'Nov 22 – Dez 21' },
  { key: 'capricorn',   name: 'Capricórnio',  emoji: '♑', element: 'Terra', dates: 'Dez 22 – Jan 19' },
  { key: 'aquarius',    name: 'Aquário',      emoji: '♒', element: 'Ar',    dates: 'Jan 20 – Fev 18' },
  { key: 'pisces',      name: 'Peixes',       emoji: '♓', element: 'Água',  dates: 'Fev 19 – Mar 20' },
] as const;

export type ZodiacKey = typeof ZODIAC_SIGNS[number]['key'];

/** Return the sun sign key for a given birth date. */
export function getSunSign(birthDate: Date | string): ZodiacKey {
  const d = typeof birthDate === 'string' ? new Date(birthDate + 'T12:00:00') : birthDate;
  const month = d.getMonth() + 1; // 1-12
  const day   = d.getDate();

  if ((month === 3  && day >= 21) || (month === 4  && day <= 19)) return 'aries';
  if ((month === 4  && day >= 20) || (month === 5  && day <= 20)) return 'taurus';
  if ((month === 5  && day >= 21) || (month === 6  && day <= 20)) return 'gemini';
  if ((month === 6  && day >= 21) || (month === 7  && day <= 22)) return 'cancer';
  if ((month === 7  && day >= 23) || (month === 8  && day <= 22)) return 'leo';
  if ((month === 8  && day >= 23) || (month === 9  && day <= 22)) return 'virgo';
  if ((month === 9  && day >= 23) || (month === 10 && day <= 22)) return 'libra';
  if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return 'scorpio';
  if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return 'sagittarius';
  if ((month === 12 && day >= 22) || (month === 1  && day <= 19)) return 'capricorn';
  if ((month === 1  && day >= 20) || (month === 2  && day <= 18)) return 'aquarius';
  return 'pisces';
}

/** Return zodiac sign metadata by key. */
export function getSign(key: ZodiacKey) {
  return ZODIAC_SIGNS.find(s => s.key === key);
}

/** Return the Portuguese name for a sign key. */
export function getSignName(key: string): string {
  return ZODIAC_SIGNS.find(s => s.key === key)?.name ?? key;
}

/** Return the emoji for a sign key. */
export function getSignEmoji(key: string): string {
  return ZODIAC_SIGNS.find(s => s.key === key)?.emoji ?? '✦';
}
